class Lists {
  constructor(api) {
    this.api = api;
  }

  getListOfLists(queryParams, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/listOfLists" + (params === "" ? "" : params))
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editList(uuid, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("v1/listOfLists/" + uuid, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  downloadLists(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/lists/export/excel")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAll(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/lists")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByType(listName, filters, onSuccess, onError) {
    let urlFilters = "";
    if (filters) {
      let preparedFilters = [];
      for (const filter of filters) {
        preparedFilters.push("filters[" + filter.field + "]=" + filter.value);
      }
      urlFilters = "?" + preparedFilters.join("&");
    }
    return this.api.http_fibercloud
      .get("v1/lists/" + listName + urlFilters)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createListItem(listName, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/lists/" + listName + "/item", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editListItem(listName, itemCode, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("v1/lists/" + listName + "/item/" + itemCode, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteListItem(listName, itemCode, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/lists/" + listName + "/item/" + itemCode)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/api/lists.js